import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Paper
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * FaqDeleteDialog Component - Confirmation dialog for deleting FAQs
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether dialog is open
 * @param {Function} props.onClose - Function to close dialog
 * @param {Object} props.faq - FAQ data to delete
 * @param {Function} props.onConfirm - Function to confirm deletion
 */
const FaqDeleteDialog = ({ open, onClose, faq, onConfirm }) => {
  if (!faq) return null;
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'error.main' }}>
          刪除常見問題
        </Typography>
        <IconButton 
          aria-label="close" 
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <WarningAmberIcon color="warning" sx={{ fontSize: 32 }} />
            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
              確定要刪除此常見問題嗎？此操作無法復原。
            </Typography>
          </Box>
          
          <Paper
            variant="outlined"
            sx={{ p: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}
          >
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              問題:
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {faq.question}
            </Typography>
            
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              答案:
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {faq.answer}
            </Typography>
            
            {faq.category && (
              <>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                  分類:
                </Typography>
                <Typography variant="body1">
                  {faq.category}
                </Typography>
              </>
            )}
          </Paper>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, pt: 1.5 }}>
        <Button 
          variant="outlined" 
          onClick={onClose}
        >
          取消
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => onConfirm(faq.id)}
          startIcon={<DeleteOutlineIcon />}
        >
          確認刪除
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FaqDeleteDialog;